export const mbaAndEmbaStudentSpotlightCarouselProps = {
    streamIds: [
        '48097b931760f6181a4519979bdbe1b7',
        'cf2e845bb11902c06b883541c5168e19',
        '8b4772513d0f224728ebb48ff95c81af',
        '2d9b88500adac51711584d1e1650b25f',
        '52dd5b720075b5288519030ccf098fed',
        'b07f335f184c2b6a0f821e2894a77975',
        '6f013d4791218ef56089f7c7b502493c',
        '274b390897ebd892b72efdb05c796bc8',
        '2e01fbb52627e83f9b55593ca9105293',
        '52177b598fece210c62a6e914c47eccc',
        '6e067d87d7cd693238710357ff3dcd6c',
        '00953f8a700491b3f0a56a52b36a9fbf',
        '09195245efdcc79219ba021c7b134373',
        'e190cd25887c5f28e26a01dd156fea9c',
        '09ff62f2e306f4d29d7af417fb1a6bbf',
        '46b82bfa2870bb996d8b39fba31f30ee',
    ],
};

export const valarMbaAndEmbaStudentSpotlightCarouselProps = {
    streamIds: [
        '0b31d3c42f5f5b60cf396e9a72cad12f',
        '0f4b4c1f2e1bbf26c3791637927ea4d1',
        'b4fc6c44a931f502040e7da62a5d57f2',
        '86c9eeb319c9d3dbc1b5a5da823b43f7',
        '7fdeb36fde440924b195a82009cf7d66',
    ],
    showInstitutionLogo: true,
};
